const OutageExperienceIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M12.0001 6.66667H9.33341C8.62617 6.66667 7.94789 6.94762 7.4478 7.44772C6.9477 7.94781 6.66675 8.62609 6.66675 9.33333V25.3333C6.66675 26.0406 6.9477 26.7189 7.4478 27.219C7.94789 27.719 8.62617 28 9.33341 28H22.6667C23.374 28 24.0523 27.719 24.5524 27.219C25.0525 26.7189 25.3334 26.0406 25.3334 25.3333V9.33333C25.3334 8.62609 25.0525 7.94781 24.5524 7.44772C24.0523 6.94762 23.374 6.66667 22.6667 6.66667H20.0001M12.0001 6.66667C12.0001 7.37391 12.281 8.05219 12.7811 8.55229C13.2812 9.05238 13.9595 9.33333 14.6667 9.33333H17.3334C18.0407 9.33333 18.7189 9.05238 19.219 8.55229C19.7191 8.05219 20.0001 7.37391 20.0001 6.66667M12.0001 6.66667C12.0001 5.95942 12.281 5.28115 12.7811 4.78105C13.2812 4.28095 13.9595 4 14.6667 4H17.3334C18.0407 4 18.7189 4.28095 19.219 4.78105C19.7191 5.28115 20.0001 5.95942 20.0001 6.66667M12.0001 18.6667L14.6667 21.3333L20.0001 16"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export default OutageExperienceIcon;
